/**
 * Represents the types of plants.
 */
export enum PlantsTypeEnum {
  VerdunstungskühlanlagenVKA = "evaporative_cooling_systems_vka",
  Solarthermie = "solar_thermal_energy",
  Kessel = "boiler",
  HeatingWater = "heating_water",
  KälteSpitzenwärme = "cold_peak_heat",
  Geothematisch = "geothematic",
  Sprinkler = "sprinkler",
  Klimaanlage = "air_conditioner",
  Trinkwasser = "drinking_water",
  Brunnen = "spring",
  Zusatzwasser = "additional_water",
  Nassabscheider = "wet_separator",
  GeschlossenerKuhlkreislauf = "closed_cooling_circuit",
  Abwasser = "sewage",
  Springbrunnen = "fountain",
  ZusatzwasserKesselwasser = "additional_water_boiler",
  Hauptgeäude = "main_building",
  SystemWaterAnalysisVDI6044 = "system_water_analysis_vdi6044",
  SystemWaterAnalysisVDI2035 = "system_water_analysis_vdi2035",
}
